export default "__VITE_ASSET__D7pvd$6k__"